export default {
  computed: {
    isMobileOrderingButtons() {
      const terminal = this.$store.getters["terminal/terminal"]

      return terminal?.mobile_layout === "mobileordering_buttons"
    },
  },
}
